
import { mapActions, mapGetters } from 'vuex'

import TotalSaturationCurve from '@/components/budgetSimulator/TotalSaturationCurve.vue'
import { budgetSimulation } from '@/mixins/budgetSimulation.js'

export default {
  mixins: [budgetSimulation],
  components: {
    TotalSaturationCurve
  },
  props: {
    simulation: {
      type: Object,
      required: true
    },
    points: {
      type: Array,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    report: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      currentKpi: null,
      deleteDialog: false,
      settingsDialog: false,
      settingsShowToExternalUsers: false
    }
  },
  computed: {
    ...mapGetters('auth', ['authUser']),
    gridFrom () {
      const grid = this.simulation.grid || []
      return grid.length > 0 ? grid[0].pct : 0
    },
    gridTo () {
      const grid = this.simulation.grid || []
      return grid.length > 0 ? grid[grid.length - 1].pct : 0
    },
    frozenMix () {
      const mix = this.simulation.mix || {}
      return Object.keys(mix)
        .filter(channel => mix[channel] > 0)
        .sort((a, b) => mix[b] - mix[a])
        .map(channel => ({ channel: channel, label: this.channelLabels[channel] || channel, value: mix[channel] }))
    },
    // The preview always shows one KPI, so its title names it when the model has several.
    curveTitle () {
      const title = this.$t('components.budgetSimulator.BudgetSimulation.totalSaturationCurve')
      return this.kpiNames.length > 1 && this.currentKpi ? `${title} · ${this.currentKpi}` : title
    }
  },
  methods: {
    ...mapActions('simulations', ['deleteSimulation', 'updateSimulationSettings']),
    viewMore () {
      this.$router.push({ name: 'budgetSimulationDetails', params: { id: this.simulation.id } })
    },
    openSettings () {
      this.settingsShowToExternalUsers = this.simulation.showToExternalUsers || false
      this.settingsDialog = true
    },
    saveSettings () {
      this.updateSimulationSettings({
        client: this.client.id,
        simulation: this.simulation.id,
        settings: { showToExternalUsers: this.settingsShowToExternalUsers }
      })
      this.settingsDialog = false
    },
    remove () {
      this.deleteDialog = false
      this.deleteSimulation({ client: this.client.id, simulation: this.simulation.id })
    },
    viewJSON () {
      console.log(JSON.stringify({ simulation: this.simulation, points: this.points }))
    }
  }
}
